<script>
	import { fly, fade } from 'svelte/transition';
	import Icon from './lib/Icon.svelte';
	import { HELP_GUIDES } from './lib/helpGuides.js';

	let { onNavigate = (_view) => {} } = $props();

	let currentId = $state(null);
	let current = $derived(HELP_GUIDES.find(g => g.id === currentId) || null);

	function open(id) { currentId = id; }
	function back() { currentId = null; }
</script>

<div class="help-view">
	<div class="toolbar">
		<div class="left">
			{#if current}
				<button class="back" onclick={back}><Icon name="arrow-left" size={16} /> Volver</button>
			{/if}
			<div>
				<h2 class="title">{current ? current.title : 'Centro de Ayuda'}</h2>
				<p class="muted">
					{current ? current.intro : 'Guías paso a paso para sacarle el máximo a cada herramienta.'}
				</p>
			</div>
		</div>
	</div>

	<div class="body">
		{#if !current}
			<!-- Índice -->
			<div class="guide-grid">
				{#each HELP_GUIDES as g, i (g.id)}
					<button class="guide-card" onclick={() => open(g.id)} in:fly={{ y: 10, duration: 200, delay: i * 50 }}>
						<div class="guide-icon"><Icon name={g.icon} size={20} /></div>
						<div class="guide-text">
							<span class="guide-topic">{g.topic}</span>
							<h3>{g.title}</h3>
							<p>{g.intro}</p>
						</div>
						<div class="guide-foot">
							<span class="steps-badge">{g.steps.length} pasos</span>
							<Icon name="arrow-right" size={15} />
						</div>
					</button>
				{/each}
			</div>
		{:else}
			<!-- Detalle -->
			{#key current.id}
				<div class="detail" in:fly={{ x: 16, duration: 200 }}>
					<ol class="steps">
						{#each current.steps as step, i}
							<li in:fade={{ duration: 180, delay: 60 + i * 50 }}>
								<span class="step-num">{i + 1}</span>
								<div class="step-text">
									<h4>{step.title}</h4>
									<p>{step.body}</p>
								</div>
							</li>
						{/each}
					</ol>
					<div class="detail-cta">
						<button class="btn btn-primary" onclick={() => onNavigate(current.cta.view)}>
							{current.cta.label}
							<Icon name="arrow-right" size={14} />
						</button>
					</div>
				</div>
			{/key}
		{/if}
	</div>
</div>

<style>
	.help-view { height: 100%; display: flex; flex-direction: column; background: var(--surface-1); }
	.toolbar {
		padding: 18px 24px;
		background: var(--surface-0);
		border-bottom: 1px solid var(--border-1);
		flex-shrink: 0;
	}
	.left { display: flex; align-items: flex-start; gap: 14px; }
	.back {
		display: inline-flex; align-items: center; gap: 5px;
		font-size: 13px; font-weight: 600; color: var(--text-2);
		padding: 6px 10px; border-radius: 7px; margin-top: 2px;
	}
	.back:hover { background: var(--surface-2); color: var(--text-1); }
	.title { font-size: 17px; margin-bottom: 4px; }
	.muted { color: var(--text-3); font-size: 12.5px; line-height: 1.55; max-width: 640px; margin: 0; }
	.body { flex: 1; overflow-y: auto; padding: 20px 24px 28px; }

	.guide-grid {
		display: grid;
		grid-template-columns: repeat(auto-fill, minmax(290px, 1fr));
		gap: 14px;
	}
	.guide-card {
		display: flex; flex-direction: column; gap: 12px;
		padding: 18px;
		background: var(--surface-0);
		border: 1px solid var(--border-1);
		border-radius: 12px;
		text-align: left; cursor: pointer;
		transition: border-color var(--transition-fast), box-shadow var(--transition-fast), transform var(--transition-fast);
	}
	.guide-card:hover { border-color: var(--accent); box-shadow: var(--shadow-sm); transform: translateY(-2px); }
	.guide-icon {
		width: 42px; height: 42px;
		border-radius: 10px;
		background: var(--accent-soft); color: var(--accent);
		display: flex; align-items: center; justify-content: center;
	}
	.guide-text { flex: 1; }
	.guide-topic {
		font-size: 10.5px; font-weight: 700; text-transform: uppercase; letter-spacing: .05em;
		color: var(--accent);
	}
	.guide-text h3 { font-size: 15px; margin: 3px 0 5px; color: var(--text-1); }
	.guide-text p { font-size: 12.5px; line-height: 1.5; color: var(--text-3); margin: 0; }
	.guide-foot { display: flex; align-items: center; justify-content: space-between; color: var(--text-3); }
	.steps-badge {
		font-size: 11px; font-weight: 600; color: var(--text-2);
		background: var(--surface-2); padding: 3px 9px; border-radius: 5px;
	}

	.detail { max-width: 720px; }
	.steps { list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; gap: 14px; }
	.steps li { display: flex; gap: 14px; align-items: flex-start; }
	.step-num {
		width: 30px; height: 30px; flex-shrink: 0;
		border-radius: 50%;
		background: var(--accent); color: #fff;
		display: flex; align-items: center; justify-content: center;
		font-size: 13px; font-weight: 700;
	}
	.step-text { padding-top: 2px; }
	.step-text h4 { font-size: 14px; margin: 0 0 4px; color: var(--text-1); }
	.step-text p { font-size: 13px; line-height: 1.55; color: var(--text-2); margin: 0; }
	.detail-cta { margin-top: 26px; }
</style>
